import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomModule } from 'angular/custom/custom.module';
import { StoragePeriodTypePickerComponent } from 'angular/storage/storage-period-type-picker.component';
import { CollapseModule } from 'ngx-bootstrap';
import { StorageAdminPrismaCreditLimitCheckFormComponent } from './storage-admin-prisma-credit-limit-check-form.component';
import { StorageAdminPrismaCreditLimitCheckComponent } from './storage-admin-prisma-credit-limit-check.component';
import { StorageAdvancedSettingsComponent } from './storage-advanced-settings.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CustomModule,
        FormsModule,
        CollapseModule
    ],
    exports: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent
    ],
    declarations: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent,
        StorageAdminPrismaCreditLimitCheckFormComponent,
        StoragePeriodTypePickerComponent
    ],
    entryComponents: [
        StorageAdvancedSettingsComponent,
        StorageAdminPrismaCreditLimitCheckComponent
    ]
})
export class StorageModule {}
